import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PermissionGroup } from 'src/app/constants/settings.enum';
import { PermissionModel } from 'src/app/models/api/permission.model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PermissionsService } from '../../permissions.service';
import { LevelEnum } from 'src/app/constants/level.enum';
@Component({
  selector: 'app-permission-list',
  templateUrl: './permission-list.component.html'
})
export class PermissionListComponent implements OnInit, OnDestroy {
  private _permissionGroup!: PermissionGroup;
  @Input() set permissionGroup(group: PermissionGroup) {
    this._permissionGroup = group;
  }
  get permissionGroup(): PermissionGroup {
    return this._permissionGroup;
  }
  /** whether the configurations should be hidden if set (used to differentiate between permission page) */
  @Input() showWhenHidden: boolean = false;
  private _level!: LevelEnum;
  showForce: boolean = false;
  @Input() set level(level: LevelEnum) {
    this._level = level;
    this.showForce = level !== LevelEnum.OrganisationLevel;
  }
  get level(): LevelEnum {
    return this._level;
  }
  permissions: PermissionModel[] = [];
  showConfig: boolean = false;
  showDisabledHeader: boolean = false;
  authenticationServiceSubscription: Subscription;
  permissionsUpdatedSubscription: Subscription;
  constructor(private authenticationService: AuthenticationService,
    private permissionsService: PermissionsService) {
    this.authenticationServiceSubscription = this.authenticationService.currentUser.subscribe((data) => {
      this.showConfig = (data.isSystemAdmin || data.isWhitelabelAdmin);
      this.showDisabledHeader = (data.isSystemAdmin);
    });
    this.permissionsUpdatedSubscription = this.permissionsService.permissionsUpdated.subscribe(unneededValue => {
      this.getPermissions();
    });
  }
  
  ngOnInit(): void {
    this.getPermissions();
  }

  ngOnDestroy(): void {
    if (this.authenticationServiceSubscription) {
      this.authenticationServiceSubscription.unsubscribe();
    }
    if (this.permissionsUpdatedSubscription) {
      this.permissionsUpdatedSubscription.unsubscribe();
    }
  }
  async getPermissions() {
    this.permissions = this.permissionsService.GetPermissions(this.permissionGroup);
    this.permissions = this.permissions.sort((a, b) => a.positionInGroup - b.positionInGroup)
  }
  update(key: any, value: any) {
    this.permissionsService.UpdatePermission(key, value, this.level);
  }
}